import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import { useHistory } from 'react-router-dom';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Error, Success } from '../Alert/index';
import api from '../../services/api';

export function UsersList () {
  const history = useHistory();
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const [users, setUsers] = useState([]);

  // Busca lista de usuários
  useEffect(() => {
    api.get('/radius')
      .then((res) => {
        res.data.forEach((user) => {
          user.value = '********';
        });
        setUsers(res.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        }
      });
  }, [history]);

  function addUser (newValue) {
    api.post('/radius', {
      username: newValue.username,
      password: newValue.value,
    })
      .then((res) => {
        res.data.forEach((user) => {
          user.value = '********';
        });
        setUsers(res.data);
        setSuccess(true);
        document.getElementById('msgSuccess').innerHTML = 'Usuário cadastrado com sucesso!';
        setTimeout(() => setSuccess(false), 3000);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        } else {
          setError(true);
          document.getElementById('msgError').innerHTML = err;
          setTimeout(() => setError(false), 3000);
        }
      });
  }

  function updateUser (newValue, oldValue) {
    if (newValue.value !== oldValue.value) {
      api.put('/radius', {
        id: newValue.id,
        username: newValue.username,
        password: newValue.value,
      })
        .then((res) => {
          res.data.forEach((user) => {
            user.value = '********';
          });
          setUsers(res.data);
          setSuccess(true);
          document.getElementById('msgSuccess').innerHTML = 'Usuário atualizado com sucesso!';
          setTimeout(() => setSuccess(false), 3000);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            setError(true);
            const element = document.getElementById('msgError');
            element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
            setTimeout(() => {
              localStorage.removeItem('logged');
              localStorage.removeItem('realm');
              history.go('/login');
            }, 2000);
          } else {
            setError(true);
            document.getElementById('msgError').innerHTML = err.response.data.error;
            setTimeout(() => setError(false), 3000);
          }
        });
    } else {
      api.put('/radius', {
        id: newValue.id,
        username: newValue.username,
      })
        .then((res) => {
          res.data.forEach((user) => {
            user.value = '********';
          });
          setUsers(res.data);
          setSuccess(true);
          document.getElementById('msgSuccess').innerHTML = 'Usuário atualizado com sucesso!';
          setTimeout(() => setSuccess(false), 3000);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            setError(true);
            const element = document.getElementById('msgError');
            element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
            setTimeout(() => {
              localStorage.removeItem('logged');
              localStorage.removeItem('realm');
              history.go('/login');
            }, 2000);
          } else {
            setError(true);
            document.getElementById('msgError').innerHTML = err.response.data.error;
            setTimeout(() => setError(false), 3000);
          }
        });
    }
  }

  function deleteUser (oldValue) {
    api.delete(`/radius/${oldValue.id}`)
      .then((res) => {
        res.data.forEach((user) => {
          user.value = '********';
        });
        setUsers(res.data);
        setSuccess(true);
        document.getElementById('msgSuccess').innerHTML = 'Usuário removido com sucesso!';
        setTimeout(() => setSuccess(false), 3000);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        } else {
          setError(true);
          document.getElementById('msgError').innerHTML = err.response.data.error;
          setTimeout(() => setError(false), 3000);
        }
      });
  }

  async function usersUpdate () {
    try {
      const res = await api.get('/radius');
      res.data.forEach((user) => {
        user.value = '********';
      });
      setUsers(res.data);
    } catch (err) {
      if (err.response.status === 401) {
        setError(true);
        const element = document.getElementById('msgError');
        element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
        setTimeout(() => {
          localStorage.removeItem('logged');
          localStorage.removeItem('realm');
          history.go('/login');
        }, 2000);
      }
    }
  }
  return (
    <div className="content-list">
      {error ? <Error><p id="msgError" /></Error> : null}
      {success ? <Success><p id="msgSuccess" /></Success> : null}
      <section className="update">
        <div
          className="update-table"
          onClick={usersUpdate}
          aria-hidden="true"
        >
          <p>Atualizar</p>
          <FontAwesomeIcon icon={faSyncAlt} size="lg" color="white" />
        </div>
      </section>
      <MaterialTable
        title="Usuários"
        columns={[
          { title: 'RA', field: 'username' },
          { title: 'Senha', field: 'value' },
        ]}
        localization={{
          header: {
            actions: 'Oções',
          },
          body: {
            emptyDataSourceMessage: 'Sem dados para mostrar',
            deleteTooltip: 'Remover',
            addTooltip: 'Adicionar Usuário',
            editTooltip: 'Editar',
            editRow: {
              cancelTooltip: 'Cancelar',
              deleteText: 'Tem certeza que deseja remover',
              saveTooltip: 'Confirmar',
            },

          },
          toolbar: {
            searchPlaceholder: 'Buscar',
            searchTooltip: 'Buscar',
          },
        }}
        data={users}

        editable={{
          onRowAdd: (newData) => new Promise((resolve) => {
            addUser(newData);
            setTimeout(() => resolve(), 2000);
          }),
          onRowUpdate: (newValue, oldValue) => new Promise((resolve) => {
            updateUser(newValue, oldValue);
            setTimeout(() => resolve(), 2000);
          }),
          onRowDelete: (oldValue) => new Promise((resolve) => {
            deleteUser(oldValue);
            setTimeout(() => resolve(), 2000);
          }),
        }}
      />
    </div>
  );
}
